import { render } from "./HomeSearch.vue?vue&type=template&id=9b42131a&scoped=true"
import script from "./HomeSearch.vue?vue&type=script&lang=js"
export * from "./HomeSearch.vue?vue&type=script&lang=js"

import "./HomeSearch.vue?vue&type=style&index=0&id=9b42131a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b42131a"]])

export default __exports__